export default {"src":"/_next/static/media/logo-orange.a169ec69.svg","height":32,"width":147};